import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header_wrap" }
const _hoisted_2 = { class: "logo_wrap" }
const _hoisted_3 = { class: "utility_wrap D_only only_1240" }
const _hoisted_4 = {
  key: 0,
  class: "btn_wrap _default"
}
const _hoisted_5 = {
  key: 0,
  class: "btn_wrap _default"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: _normalizeClass([$setup.state.isScroll === false ? $setup.state.headerClass : ''])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: _normalizeClass(["menu_btn D_none", { cross: $setup.state.mobileMenuOpen }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.mobileMenu && $setup.mobileMenu(...args)))
        }, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "bar" }, null, -1),
          _createElementVNode("div", { class: "bar" }, null, -1),
          _createElementVNode("div", { class: "bar" }, null, -1)
        ]))], 2),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "icon_wrap"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: _normalizeClass($setup.state.menuOverFlag === true || $setup.state.isScroll === true ? 'black' : ''),
                  src: "img/logo.png",
                  alt: "반성매매 시민참여 플랫폼"
                }, null, 2)
              ]),
              _: 1
            })
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("a", {
            href: "http://dasi.or.kr/",
            class: "icon_wrap center_btn D_only none_1240",
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: "img/center.png",
              alt: "다시함께상담센터"
            })
          ], -1))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["nav_wrap", { active: $setup.state.mobileMenuOpen }])
        }, [
          _createVNode(_component_Menu, {
            onMouseover: _cache[1] || (_cache[1] = ($event: any) => ($setup.state.menuOverFlag = true)),
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.menuOverFlag = false)),
            customClass: $setup.state.headerClass !== undefined && $setup.state.menuOverFlag === false && $setup.state.isScroll === false,
            class: _normalizeClass({ active: $setup.state.mobileMenuOpen })
          }, null, 8, ["customClass", "class"]),
          _createElementVNode("div", _hoisted_3, [
            (!$setup.state.isLogin)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_router_link, { to: "/login" }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("로그인", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/join" }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("회원가입", -1)
                    ]))]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([$setup.state.isFloat ? 'area_login' : ''])
                }, [
                  _createElementVNode("div", {
                    class: "user_btn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.state.isFloat = !$setup.state.isFloat))
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("img", {
                      src: "img/user_icon.png",
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString($setup.user.userInfo.name) + "님", 1)
                  ]),
                  ($setup.state.isFloat)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("button", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => {
                                        $setup.router.push('/mypage');
                                        $setup.state.isFloat = false;
                                    }),
                          class: "common_btn"
                        }, " 마이페이지 "),
                        _createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args))),
                          class: "common_btn _gray"
                        }, "로그아웃")
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("a", {
            href: "",
            class: "icon_wrap center_btn D_none only_1240"
          }, [
            _createElementVNode("img", {
              src: "img/center.png",
              alt: "다시함께상담센터"
            })
          ], -1))
        ], 2),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "m_menu_bg D_none" }, null, -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["utility_wrap D_only none_1240", $setup.state.menuOverFlag === true ? 'black' : '']),
          style: {"position":"relative","justify-content":"center"}
        }, [
          (!$setup.state.isLogin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("로그인", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/join" }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("회원가입", -1)
                  ]))]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([$setup.state.isFloat ? 'area_login' : ''])
              }, [
                _createElementVNode("div", {
                  class: "user_btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.state.isFloat = !$setup.state.isFloat))
                }, [
                  _cache[17] || (_cache[17] = _createElementVNode("img", {
                    src: "img/user_icon.png",
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.user.userInfo.name) + "님", 1)
                ]),
                ($setup.state.isFloat)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("button", {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    $setup.router.push('/mypage');
                                    $setup.state.isFloat = false;
                                }),
                        class: "common_btn"
                      }, " 마이페이지 "),
                      _createElementVNode("button", {
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args))),
                        class: "common_btn _gray"
                      }, "로그아웃")
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
        ], 2)
      ])
    ], 2),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}